import AdminWidget from '../AdminWidget.js';
import Ajax from '../../../../../common/js/Ajax.js';
import Form from '../../../../../common/js/form/Form.js';

import TEMPLATE from './OrdersWidget.hbs';

export default class OrdersWidget extends AdminWidget {

	constructor($widget) {
		super($widget);

		Form.onSubmit($widget, action => {
			Ajax.rpc('/orders', {
				term: action.findField('query').val()
			}, orders => {
				action.ok();

				$.each(orders, (index, order) => {
					order.paymentState = order.paymentState.toLowerCase();
					order.shippingState = order.shippingState.toLowerCase();
				});

				$widget.find('.js_result').html(TEMPLATE(orders));
			}, error => {
				action.error('Failed to load orders', error);
			});
		});

		this.$widget.find('[type="submit"]').click();
	}

}
